import { render, staticRenderFns } from "./Tasksyc.vue?vue&type=template&id=c3508be4&scoped=true"
import script from "./Tasksyc.vue?vue&type=script&lang=js"
export * from "./Tasksyc.vue?vue&type=script&lang=js"
import style0 from "./Tasksyc.vue?vue&type=style&index=0&id=c3508be4&prod&lang=scss&scoped=true"
import style1 from "./Tasksyc.vue?vue&type=style&index=1&id=c3508be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3508be4",
  null
  
)

export default component.exports